/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { error } from '@/libs/notification';
import router from '@/router';
import {
  BusinessTypesState,
  BusinessTypesDataState,
  BusinessTypesReplaceData
} from '@/types/master/businessType';

import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';

export default {
  namespaced: true,
  state: {
    listData: [],
    replaceData: null
  },
  mutations: {
    setList(state: BusinessTypesState, payload: BusinessTypesDataState[]) {
      state.listData = payload;
    },
    setReplace(state: BusinessTypesState, payload: BusinessTypesReplaceData) {
      state.replaceData = payload;
    }
  },
  actions: {
    async fetch(context: any) {
      await axios
        .get(getBaseUrl() + '/master/business-types', {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setList', response.data);
          const replaceData: BusinessTypesReplaceData = {};
          response.data.forEach((businessType: BusinessTypesDataState) => {
            replaceData[businessType.id] = businessType.label;
          });
          context.commit('setReplace', replaceData);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
            router.push('/top');
          } else {
            router.push('/error/server');
          }
        });
    }
  }
};
